import React from 'react';
import Toggle from '../atoms/Toggle';
import { LabelText } from '../atoms/Typography';

/** Label + toggle molecule. */
export default function ToggleField({
  label = 'Active',
  checked,
  onChange,
  className = '',
}) {
  return (
    <div className={`ca-toggle-field ${className}`.trim()}>
      <LabelText>{label}</LabelText>
      <Toggle checked={checked} onChange={onChange} aria-label={label} />
    </div>
  );
}
